import _ from 'lodash';
import moment from 'moment';
import {
    OVERVIEW_PANEL_CHANGE_CURRENT,
    OVERVIEW_PANEL_GET_CURRENT,
    OVERVIEW_PANEL_IS_VISIBLE
} from '../../store/modules/overview-panel/types';
import api from '../api';
import infoBoard from '../core/infoboard';
import ColorBrewer from '../core/tools/colorbrewer';
import ColorFlatUI from '../core/tools/colorflatui';
import translate, { translateText } from '../core/tools/translate';
import environment from '../environment';
import { isNationalArea } from '../shared/validation';
import { CoreControl } from './CoreControl';
import { VectorType } from './VectorType';
import filters from '../core/filters';
import store from '../../store';
import worldMap from '../core/map';
import dataBoard from '../core/databoard';
import DataTable from '../core/charts/Datatable';
import templates from '../core/templates';

import { loading, unloading } from '../shared';
import { ResolutionLevelEnum } from '../../enuns/resolutionLevel.enum';
import DncFlexibleInfo from '../info/DncFlexibleInfo';
import AuthService from '../../services/authservice';
import { ContextEnum } from '../../enuns/context.enum';
import { FeaturePermission } from '../../constants/feature.permission.helper';
import Workspace from '../workspaces';
import { ControlType, Item } from '../workspaces/item';
const LayerInfo = (name) => require('../info').get(name);
const LayerControls = (name) => require('../controls').get(name);
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);
const infoBoardFrame = () => require('../core/infoboard').default;

const dataSourceSpread = {
    data: null,
    columns: null,
    type: null,
    isStates: false
};

export class DncFlexibleControl extends CoreControl {
    constructor() {
        const options = {
            id: 'DncFlexible',
            name: 'DncFlexible',
            label: 'UnmetDemand',
            filter: true,
            overview: true,
        };

        super(options);

        this._change = this._change.bind(this);
        this._changePeriod = this._changePeriod.bind(this);
        this.select = this.select.bind(this);
        this.changeProject = this.changeProject.bind(this);
        this.setFillColor = this.setFillColor.bind(this);
        this.setLineColor = this.setLineColor.bind(this);
        this.setRange = this.setRange.bind(this);
        this.toggleOverview = this.toggleOverview.bind(this);
        this.createFilter = this.createFilter.bind(this);
        this._filterCallback = this._filterCallback.bind(this);
        this.reload = this.reload.bind(this);
        this.colorize = this.colorize.bind(this);
        this.setLineWeight = this.setLineWeight.bind(this);
        this._getLayerOptions = this._getLayerOptions.bind(this);
    }

    static _nameLocaleType: string;
    static _idLocaleType: number;

    static getInstance() {
        if (!DncFlexibleControl._instance) {
            DncFlexibleControl._instance = new DncFlexibleControl();
        }

        return DncFlexibleControl._instance;
    }

    toggleOverview() {
        const currentMap = worldMap.getCurrent();
        const layer = this.getLayer(currentMap._id);
        const features = layer.getCurrentFeatures();

        if (!store.getters[OVERVIEW_PANEL_IS_VISIBLE] || !_.isEqual(this._overviewFeatures, features))
            api.general.log.action(environment._getContextEnum(this.options.name), 'Visualizar Gráfico');

        if (_.size(features)) {
            this.summary(features);
            this._overviewFeatures = _.cloneDeep(features);
            store.dispatch(OVERVIEW_PANEL_CHANGE_CURRENT, this.options.name);
        }
    }

    init() {
        const values = {
            help: translate(`Help.${this.options.name}`),
            id: 'layer-dnc-flexible',
            input: 'checkbox',
            label: translate(`Common.UnmetDemand`),
            layer: this.getLayer,
            change: this._change,
            fillColor: {
                name: 'fillColor',
                change: this.setFillColor
            },
            lineColor: {
                name: 'lineColor',
                change: this.setLineColor
            },
            lineWeight: {
                change: this.setLineWeight
            },
            range: {
                change: this.setRange
            },
            name: this.options.name,
            slider: 'range',
            type: 'vector-layers-extended',
            tab() {
                return $('#dnc-tab-link');
            },
            dropdown: [],
            filter: this.options.filter ? this.createFilter : null,
            overview: this.options.overview ? this.toggleOverview : null,
        };

        values.dropdown.push({
            name: 'list',
            dataSource: _.map(environment.get('CONFIG.FILTERS.DNC_FLEXIBLE_TYPES'), t =>
                ({ text: t.name, value: t.id })
            ),
            change: this.select
        });

        values.links = {};

        let config = environment.get('CONFIG');
        const flexibleDncDates = environment.get('CONFIG.FILTERS.DNC_FLEXIBLE_DATES');
        const defaultFlexDncDate = flexibleDncDates.findOrFirst(x => x.value === 4);
        config.PARAM.DNC_DATES_PERIOD = defaultFlexDncDate.value;
        environment.set('CONFIG', config);

        values.links[translate('Action.ShowDateFrom')] = {
            id: 'layer-dnc-sales-date',
            name: 'DNCByYear',
            value: defaultFlexDncDate.text,
            text: `${defaultFlexDncDate.text}`,
            dataSource: _.map(_.concat(flexibleDncDates), (val) => {
                return ({ value: val.text, text: val.text });
            }),
            change: this._changePeriod
        };


        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    callbackUpdateLegend = () => { };

    updateLegend(areaName, period) {
        const { salesType } = this.getFilters();

        let titleLegend = `${environment.get('CONFIG.CLIENT')} | ${translate(areaName)} | ${translate('Common.All')}`;

        if (salesType && salesType.value.length === 1) {
            titleLegend = `${environment.get('CONFIG.CLIENT')} | ${translate(areaName)} | ${salesType.text}`;
        }
        this.callbackUpdateLegend = () => this.updateLegend(areaName, period);

        return this.getLayer().setOptions({
            legend: {
                title: titleLegend,
                subtitle: `${this.getControls().link.DNCByYear.text} - ${period.start.format('MMM/YYYY')} - ${period.end.format('MMM/YYYY')}`,
                mask: '0,0'
            }
        });
    }

    _change(e) {
        const layer = this.getLayer();

        if (e.checked) {
            try {
                layer.options.scaleRange.setOptions({ id: this.getTypeValue(true) });
            } catch (err) {
                console.log('WARNING: no autozoom level');
            }

            infoBoard.open();
            $(`#${this.options.name}-tab-link`).trigger('click');
            layer.redraw();
        } else {
            layer.hide();
            infoBoard.toggleDashboard(false);
            this._view('reset');
            this.show({ empty: true });
            this._setFilterButtonVisibility(false);
            this._uncheckAll();
        }

        Workspace.addAction(new Item(`#${$(e).prop('id')}`, e.checked, ControlType.ICheckBox));
    }

    _view(method, feature) {
        try {
            const instance = LayerInfo(this.options.name);
            if (method === 'reset') {
                return instance[method]();
            } else {
                return instance[method](feature);
            }
        } catch (err) {
            console.log(err);
        }
    }

    _uncheckAll() {
        _.forEach(this.getControls().checkbox, control => {
            control.input.iCheck('uncheck');
        });
    }

    _changePeriod(date, id = this.getLayer().getMap()._id) {
        _.filter(environment.get('CONFIG.FILTERS.DNC_FLEXIBLE_DATES'), f => f.text === date)
            .map(f => {
                let config = environment.get('CONFIG');
                config.PARAM.DNC_DATES_PERIOD = f.value;
                environment.set('CONFIG', config);
            }).values();

        api.general.log.action(ContextEnum.LayerDncFlexible, 'Mudou Período', JSON.stringify(date));

        if (this.check() && this.getLayer().visible()) {
            this.getLayer().redraw();
        }
    }

    ObterDadosDNCSegmento_change(e) {
        const layer = this.getLayer();
        if (e.checked) {
            if (!layer.isEmpty() && layer.samePosition()) {
                layer.reload();
            } else {
                layer.redraw();
            }
        } else {
            layer.hide();
            LayerInfo(this.options.name).reset();
            this.show({ empty: true });

        }
    }

    setLineWeight(value: any) {
        const layer = this.getLayer();
        const { symbology } = layer.options;
        symbology.style.weight = value === 5 ? 0.8 : value;

        layer.setOptions({ symbology });
        if (this.check() && this.getLayer().visible()) {
            layer.reload();
        }
    }

    getType() {
        const { params } = this.getLayer().options.remote;

        if (!params.locationType) {
            this.getLayer().options.remote.params.locationType = this.getControls().dropdown.list.value;
        }

        return params.locationType;
    }

    getTypeValue() {
        return this.getType();
    }

    getLocaleTypeName() {
        return this.getControls().dropdown.list.text;
    }

    getLocaleTypeId() {
        return this.getControls().dropdown.list.value;
    }

    getPeriodicityId() {
        return environment.get('CONFIG.FILTERS.DNC_FLEXIBLE_DATES').find(x => x.text === this.getControls().link.DNCByYear.value).value;
    }

    getResolutionLevelId() {
        let localeTypes = Object
            .keys(environment.get('CONFIG.FILTERS.DNC_FLEXIBLE_TYPES'))
            .map(function (key) {
                return environment.get('CONFIG.FILTERS.DNC_FLEXIBLE_TYPES')[key];
            });
        let idLocaleTypeSelected = this.getLocaleTypeId();

        return _.find(localeTypes, function (x) {
            return x.id === parseInt(idLocaleTypeSelected);
        }).resolutionLevel;
    }

    setLocaleTypeInfo(id, name) {
        this._instance._idLocaleType = id;
        this._instance._nameLocaleType = name;
    }

    getDate(id = this.getLayer().getMap()._id) {
        if (_.isUndefined(this.date)) {
            this.date = new Map();
        }

        if (!this.date.has(id)) {
            this.date.set(id, id === 0 ? {
                start: moment(environment.get('CONFIG.FILTERS.ENDYEAR')).startOf('year'),
                end: environment.validate.date.end(moment(environment.get('CONFIG.FILTERS.ENDYEAR')).endOf('year'))
            } :
                this._date.get((id - 1)));
        }

        return this.date.get(id);
    }

    isNationalArea(value, text) {
        if (!text) {
            text = (() => {
                try {
                    return this.getControls().dropdown.list.text;
                } catch (err) {
                    console.log(err);
                    return '';
                }
            })();
        }

        if (!value) {
            value = (() => {
                try {
                    return Number(this.getControls().dropdown.list.value);
                } catch (err) {
                    console.log(err);
                    return -1;
                }
            })();
        }

        return isNationalArea(value, text);
    }

    view(method = 'create', features) {
        const controls = LayerInfo(this.options.name);
        if (!controls[method] || _.isUndefined(features)) {
            this._setFilterButtonVisibility(false);
            return;
        }

        this._setFilterButtonVisibility(true);
        return controls[method](features);
    }

    show(options = {}, features = this.getLayer().getCurrentFeatures()) {
        if ($('#dnc-collapse').length === 0 || options.refresh) {
            if (options.empty) {
                this.view('create', null);
            } else {
                this.view('create', features);
            }
        }

        if (options.show) {
            if (options.id) {
                const title = $(`#${name.toLocaleLowerCase()}-title-${options.id}`);
                return setTimeout(() => {
                    if (title[0] && !title[0].isOpen) {
                        title.trigger('click');
                    }

                    if (options.tab === 'summary') {
                        return $(`#button-${name.toLocaleLowerCase()}-summary-${options.id}`).trigger('click');
                    }
                }, 100);
            }
        }
    }

    setFillColor(value) {
        const color = value.split(':')[0];
        const index = value.split(':')[1];

        const { symbology } = this.getLayer().options;
        symbology.theme = ColorBrewer[color][index];
        symbology.heat.theme = ColorBrewer.getHeatColors(color);
        symbology.cluster.theme = ColorBrewer[color][index];
        symbology.style.highlight = ColorBrewer[color][index][Number(index) - 1];

        this.getLayer().setOptions({ symbology });
        if (this.check() && this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    setLineColor(value: any) {
        const color = value.split(':')[0];
        const index = value.split(':')[1];

        const { symbology } = this.getLayer().options;
        symbology.style.color = ColorFlatUI[color][index][0];

        this.getLayer().setOptions({ symbology });
        if (this.check() && this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    setRange(value: any) {
        const layer = this.getLayer();

        if (!this.check() || !layer.visible()) {
            return;
        }

        const values = _(layer.getCurrentFeatures()).map('properties.Value').filter(_.isNumber).value();

        if (!_.size(values)) {
            return;
        }

        const { symbology } = layer.options;
        const ratio = _.max([value / 10, 0.2]);

        symbology.min = _.min([_.min(values) * ratio, 0]);
        symbology.max = _.max([_.max(values) * ratio, 0]);

        layer.setOptions({ symbology });
        layer.reload();
    }

    changeProject(value, text) {
        if (_.isString(value)) {
            value = Number(value);
        }

        const { remote, scaleRange } = this.getLayer().options;

        scaleRange.setOptions({
            id: value,
            type: 'Project',
            property: 'idProject'
        });

        remote.params.idProject = value;

        if (this.check() && this.getLayer().visible()) {
            api.general.log.action(ContextEnum.LayerDncFlexible, 'Update Project', JSON.stringify({ Projeto: text }));
            this.getLayer().redraw();
        }
    }

    select(value, text) {
        this.view('create');

        if (_.isString(value)) {
            value = Number(value);
        }
        this.getLayer().options.remote.params.locationType = value;

        if (this.check() && this.getLayer().visible()) {
            api.general.log.action(ContextEnum.LayerDncFlexible, 'Update Localidade', JSON.stringify({ Localidade: text }));
            this.getLayer().redraw();
        }
    }

    _setFilterButtonVisibility(state: boolean) {
        if (this.options.filter) {
            try {
                if (this.getControls().button.filter.input) {
                    this.getControls().button.filter.input.enable(state);
                }

                this.getControls().button.filter.enable = state;

                if (state) {
                    // this.getControls().button.filter.type = this.getThemeValue();
                    this.createFilter();
                }

                if (!state) {
                    filters.close();
                }
            } catch (err) {
                console.log('ERROR: ', err);
            }
        }

        try {
            if (this.getControls().button.filter.input) {
                this.getControls().button.overview.input.enable(state);
            }

            this.getControls().button.overview.enable = state;

            if (!state) {
                dataBoard.hide();
                delete this._overviewFeatures;
            }
        } catch (err) {
            console.log(err);
        }
    }

    createFilter() {
        filters.create({
            container: document.getElementById('filter-container'),
            id: `filter-${_.kebabCase(this.options.name)}-${this.getLayer().getMap()._id}`,
            label: translate(`Common.${this.options.label}`),
            type: 'dncflexible',
            direction: 'up',
            onSubmit: this._filterCallback,
            fields: {
                segments: true,
                channels: isAuthorized(FeaturePermission.LAYER_DNC.salesChannel),
                companySizes: isAuthorized(FeaturePermission.LAYER_DNC.companySize),
                salesType: true
            }
        });
    }

    _filterCallback() {
        if (this.check() && this.getLayer().visible()) {
            api.general.log.action(ContextEnum.LayerDncFlexible, 'Filtro');
            this.reload();
        }

        dataBoard.hide();
        this.callbackUpdateLegend();
    }

    reload() {
        if (this.check() && this.getLayer().visible()) {
            const layer = this.getLayer();
            this._cachePages = new Map();
            this.colorize(layer.toGeoJSON(), layer);
        }
    }

    groupBy(array, key) {
        return array.reduce((acc, item) => ({
            ...acc,
            [item[key]]: [...(acc[item[key]] || []), item],
        }),
            {});
    }

    colorize(featureCollection: any, layer: any = this.getLayer()) {
        const { models, competingClassification, channels, companySizes, salesType } = this.getFilters();

        if (models || competingClassification || channels || companySizes || salesType) {
            loading();
            const segments = models
                ? models.text
                : competingClassification && _.size(competingClassification.value)
                    ? _.flatMap(competingClassification.value, key => _.map(environment.get('CONFIG.FILTERS.COMPETING_SEGMENTS')[key], v => translateText(v.nome, true)))
                    : undefined;
            const idsSaleChannels = channels ? channels.value : undefined;
            const idsCompanySize = companySizes ? companySizes.value : undefined;
            const idsSalesType = salesType ? salesType.value : undefined;
            let data = [];

            featureCollection.features.forEach(f => {
                if (f.properties.DncValues) {
                    data = f.properties.DncValues.filter(x =>
                        (!segments || segments.includes(x.nameSegment.toUpperCase()))
                        && (!idsSaleChannels || idsSaleChannels.includes(x.idSaleChannel))
                        && (!idsCompanySize || idsCompanySize.includes(x.companySize))
                        && (!idsSalesType || idsSalesType.includes(x.idSaleType)));

                    const dncValuesBySegment = this.groupBy(data, 'nameSegment');

                    const dncValues = Object.keys(dncValuesBySegment)
                        .map(seg => dncValuesBySegment[seg].reduce((acc, cur) => acc + cur.dncValue, 0))
                        .reduce((acc, cur) => acc + Math.round(cur), 0);

                    f.properties.Value = parseInt(dncValues.toFixed(0)) || 0;
                }
            });
            const layer = this.getLayer();

            layer.setFeatures(featureCollection, true);
            unloading();
            return;
        }

        featureCollection.features.forEach(f => {
            const dncValuesBySegment = this.groupBy(f.properties.DncValues, 'nameSegment');

            const dncValues = Object.keys(dncValuesBySegment)
                .map(seg => dncValuesBySegment[seg].reduce((acc, cur) => acc + cur.dncValue, 0))
                .reduce((acc, cur) => acc + Math.round(cur), 0);

            if (dncValues) {
                f.properties.Value = parseInt(dncValues.toFixed(0)) || 0;
            }
        });

        layer.setFeatures(featureCollection, true);
    }

    _setFeaturesValue(featureCollection: any, values: any) {
        let result = {
            destroy: true,
            type: 'FeatureCollection',
            features: _.map(featureCollection.features, f => {
                f.properties.Value = _.get(values.consolidate, f.properties.Id) || 0;
                return f;
            })
        };

        return result;
    }

    getFilters() {
        const layer = this.getLayer();
        const id = layer.getMap()._id;
        const filterData = filters.get(`filter-${_.kebabCase(this.options.name)}-${this.getLayer().getMap()._id}`, id) || {};

        return filterData;
    }

    getFilterControl(mapId) {
        const filterData = filters.get(`filter-${_.kebabCase(this.options.name)}-${mapId}`, mapId) || {};
        return filterData;
    }

    _getLayerOptions(featureCollection: any = this.getLayer().toGeoJSON(), id: number) {
        const filterData = filters.get(`filter-${_.kebabCase(this.options.name)}-${this.getLayer().getMap()._id}`, id) || {};
        const options = {
            idTema: 23,
            ids: featureCollection.features.map(f => f.properties.Id),
            idTipo: LayerControls(this.options.name).getType(),
            anoMesInicio: this.getDate(id).start.format('YYYYMM'),
            anoMesFim: this.getDate(id).end.format('YYYYMM'),
            periodo: environment.get('CONFIG.PARAM.DNC_DATES_PERIOD'),
            salesChannel: undefined,
        };

        if (filterData.models) {
            options.idsCategorias = filterData.models.value;
        } else if (filterData.competingClassification && _.size(filterData.competingClassification.value)) {
            options.idsCategorias = _.flatMap(filterData.competingClassification.value, key => _.map(environment.get('CONFIG.FILTERS.COMPETING_SEGMENTS')[key], 'id'));
        }

        if (filterData.channels) {
            options.salesChannel = filterData.channels.value;
        }

        return options;
    }

    showSummaryInfo(features, dncIdLocaleSelected) {
        const dncValue = _.find(features, x => x.properties.DncIdLocale === dncIdLocaleSelected);
        DncFlexibleInfo.getInstance()._showSummary(dncValue);
    }

    showNeodashDncFlexible(url) {
        $(`#dnc-container`).empty();
        infoBoardFrame().toggleDataboard(true, '100%', 'down', '#dnc-container');
        let $template = $(templates('dashboard-view-no-header', { url }));
        $template.prependTo(`#dnc-container`);
    }

    summary(features) {

        const summary = _(features)
            .orderBy(f => f.properties.Value)
            .map(f => ({
                name: f.properties.Nome,
                total: f.properties.Value,
                dncIdLocale: f.properties.DncIdLocale
            }))
            .value();

        const period = {
            start: moment(features[0].properties.DncValues[0].getInitialDate),
            end: moment(features[0].properties.DncValues[0].getFinalDate)
        };

        const dataCharColumn = _(features)
            .map(f => ({
                [translate('Common.Name')]: f.properties.Nome,
                [translate('Common.Total')]: parseInt(f.properties.Value),
                ['DncIdLocale']: f.properties.DncIdLocale,
            }))
            .orderBy(translate('Common.Total'), 'asc')
            .value();

        const chartColumn = new DataTable(dataCharColumn, {
            row: translate('Common.Name'),
            column: [translate('Common.Total')],
            dncIdLocale: ['DncIdLocale']
        });

        const onSeriesClick = (e) => {
            const apiKey = AuthService.getAccessTokenHeader().Authorization.replace('Bearer ', '');
            const user = _.escape(sessionStorage.username);
            const period = environment.get('CONFIG.PARAM.DNC_DATES_PERIOD');

            switch (this.getResolutionLevelId()) {
                case ResolutionLevelEnum.AgrupamentoSetores:
                    this.showSummaryInfo(features, e.series.dncIdLocale);
                    break;
                case ResolutionLevelEnum.Municipio:
                    this.showNeodashDncFlexible(`${environment.get('NEODASH_HOST')}/dnc/hide/project/${this.getProjectId()}/comparisonBasket/${e.series.dncIdLocale}/edit`);
                    break;
                default:
                    this.showNeodashDncFlexible(`${environment.get('NEODASH_HOST')}/dnc/hide/project/${this.getProjectId()}/localeAgg/report/detail/${e.series.dncIdLocale}/${period}?user=${user}&apikey=${apiKey}`);
                    break;
            }
        };

        let buttons = {
            fullscreen: true,
        };

        const options = {
            title: {
                table: `${translate(`Common.${this.options.label}`)}`,
                chartColumn: `RANKING DNC`,
            },
            size: '40%',
            chart: true,
            chartSplit: true,
            colorReverse: true,
            titleHeader: true,
            limit: _.size(summary),
            titleHeaderMessage: `Sumário - DNC  | ${period.start.format('MMM/YYYY')} - ${period.end.format('MMM/YYYY')}`,
            data: [summary, chartColumn],
            convertTable: false,
            columns: [
                {
                    field: 'name',
                    title: translate('Common.Name')
                },
                {
                    field: 'total',
                    title: translate('Common.Total'),
                    width: 100,
                }
            ],
            buttons: buttons,
            seriesClick: onSeriesClick,
        };
        dataSourceSpread.isStates = parseInt(this.getControls().dropdown.list.value) === 3;
        dataSourceSpread.type = this.getControls().dropdown.list.text;
        dataSourceSpread.data = _.cloneDeep(summary);
        dataSourceSpread.columns = _.cloneDeep(options.columns);
        dataBoard.show(options);
    }
}

export default DncFlexibleControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/DncFlexibleControl.js